export enum CoverageStatus {
  ACTIVE = "Active",
  /** Value stored in `coverage.coverage_status` by EV/RPA for an active plan. */
  ACTIVE_COVERAGE = "Active Coverage",
  IN_PROGRESS = "In Progress",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  ERROR = "Error",
  COMPLETED = "Completed",
  INACTIVE = "Inactive",
  EV_TYPE_NOT_SUPPORTED = "EV Type Not Supported",
  UNKNOWN = "Unknown",
}
